import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
import LaboratoryService from '../services/LaboratoryService';
export default function getTimelineMonocytes(_x, _x2) {
  return _getTimelineMonocytes.apply(this, arguments);
}

function _getTimelineMonocytes() {
  _getTimelineMonocytes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(startDate, endDate) {
    var laboratoryService, params, labs, timelineData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            laboratoryService = new LaboratoryService();
            params = [{
              date: "ge".concat(moment(startDate).hour(0).minute(0).second(0).utc().toISOString())
            }, {
              date: "le".concat(moment(endDate).hour(23).minute(59).second(59).utc().toISOString())
            }, {
              code: 'http://loinc.org|26484-6'
            }, {
              _sort: '-date',
              _count: 100000,
              // TODO: any way to unlimit in fhir?
              _elements: 'effectiveDateTime,valueQuantity'
            }];
            _context.next = 4;
            return laboratoryService.fetchData(params);

          case 4:
            labs = _context.sent;
            timelineData = [];
            labs.forEach(function (labsItem) {
              if (!labsItem.date || !labsItem.monocytes) {
                return;
              }

              timelineData.push({
                date: labsItem.date,
                value: labsItem.monocytes
              });
            });
            return _context.abrupt("return", timelineData.map(function (data) {
              if (data.value.split) {
                data.value = parseInt(data.value.split(' ')[0], 10);
              }

              return data;
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getTimelineMonocytes.apply(this, arguments);
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getTimelineMonocytes, "getTimelineMonocytes", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/timelineData/getTimelineMonocytes.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();